const ym: any = window.ym || ((): any => void 0);

/* eslint-disable no-unused-expressions */
export function setMetrics(...list: string[]): void {
  // @ts-ignore
  ym(window.counterId, ...list)
}
